

























































































































import { Vue, Component } from 'vue-property-decorator';
import { RadioGroup, Radio, Popup, Toast } from 'vant';
import { getList, saves } from '../api';
import { inAppAlertLogin, isWeiXin } from '@/common/ts/common';
Vue.use(Radio)
  .use(RadioGroup)
  .use(Popup);
@Component({
  components: {
    Radio,
    RadioGroup,
  },
})
export default class Rule extends Vue {
  textData: any = [];
  isSave = false;
  radioImg: any = null;
  radioImgs: any = [];
  radio: string = 'A';
  problemNum = 0;
  btn = require('../assets/btn.png');
  debtn = require('../assets/deBtn.png');
  resArr: any = [];
  saveData: any = [];
  answerId = '';
  answer = '';
  copyData: any = [];
  btnStatus = false;
  async mounted() {
    const res: any = await getList();
    if (res.code === 505) {
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else if (res.code !== 200) {
      Toast.fail(res.msg);
    }
    this.resArr = res.data;
    this.copyData = JSON.parse(JSON.stringify(res.data));
  }
  change(e: any) {
    console.log(999, e);
  }
  selectItem(index: any, id: any) {
    if (this.saveData[this.problemNum]) {
      this.saveData[this.problemNum].answer = '';
    }
    if (this.radioImg === index) {
      this.radioImg = null;
    } else {
      this.radioImg = index;
    }
    this.answerId = id;
    if (!this.problemNum) {
      this.resArr = JSON.parse(JSON.stringify(this.copyData));
      const type1 = ['A', 'B', 'C', 'E'];
      const type2 = ['G'];
      const type3 = ['F', 'H', 'I', 'J'];
      if (type1.includes(index)) {
        this.resArr.splice(3, 1);
      } else if (type2.includes(index)) {
        this.resArr.splice(4, 1);
        this.resArr.splice(2, 1);
      } else {
        this.resArr.splice(2, 3);
      }
    }
  }
  selectItems(index: number, id: any) {
    // this.radioImg = index;
    this.answerId = id;
    if (this.radioImgs.length) {
      if (this.radioImgs.includes(index)) {
        this.radioImgs.map((item: any, indexs: number) => {
          if (item === index) {
            this.radioImgs.splice(indexs, 1);
          }
        });
      } else if (this.radioImgs.length < 3) {
        this.radioImgs.push(index);
      }
    } else if (this.radioImgs.length < 3) {
      this.radioImgs.push(index);
    }
  }
  async next(type: string, required: string) {
    if (
      ((type === '1' && !this.radioImg) ||
        (type === '2' && !this.radioImgs.length)) &&
      required !== '2'
    ) {
      return false;
    }
    if (this.problemNum !== this.resArr.length - 1) {
      let data = {};
      if (type === '1') {
        data = {
          answer_id: this.answerId,
          answer: this.radioImg,
        };
      } else if (type === '2') {
        data = {
          answer_id: this.answerId,
          answer: this.radioImgs.join('|'),
        };
      } else if (type === '3') {
        data = {
          answer_id: this.resArr[this.problemNum].id,
          answer: Object.values(this.textData).join('|'),
        };
      }
      this.saveData.push(data);
      this.problemNum += 1;
      this.radioImg = null;
      this.radioImgs = [];
      this.textData = [];
    } else {
      let data = {};
      data = {
        answer_id: this.resArr[this.problemNum].id,
        answer: Object.values(this.textData).join('|'),
      };

      this.saveData.push(data);
      const ids: any = [];
      const answers: any = [];
      let saveData: any;
      if (isWeiXin()) {
        saveData = {
          unionid: window.localStorage.getItem('unionid'),
          //   nickname: window.localStorage.getItem('nickname'),
          answer: this.saveData,
          id: this.$route.query.id,
        };
      } else {
        saveData = {
          answer: this.saveData,
          id: this.$route.query.id,
        };
      }
      console.log(11111, saveData);
      const res: any = await saves(saveData);
      if (res.code === 200) {
        this.isSave = true;
        setTimeout(() => {
          this.$router.push('home');
        }, 3000);
      } else if (res.code === 505) {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        this.saveData.splice(this.saveData.length - 1, 1);
        Toast.fail(res.msg);
      }
    }
  }
  // pro() {
  //   if (this.problemNum > 0) {
  //     // this.saveData.splice(this.problemNum, 1);
  //     this.problemNum -= 1;
  //     this.radioImg = null;
  //     this.radioImgs = [];
  //   }
  // }
}
